const routes = {
  airportCreate: "/airports/create",
  airportUpdate: "/airports/:id/update",
  airportDelete: "/airports/:id/delete",
  airportDetail: "/airports/:id",
  airportList: "/airports",
}

export default routes
